import React, { useEffect, useRef } from "react";
import pdf from "../pdf/resume.pdf";
import hero from "./data/hero.json";
import { TypeAnimation } from 'react-type-animation';

const Home = () => {

  return (
    <div className="container text-center my-5" id="home" style={{zIndex:3}}>
      <div className="row home overflow-hidden px-5" id="home">
        <div className="col-lg-6 col-md-6 col-sm-12 my-5 mx-auto left" data-aos="fade-up-right" data-aos-duration="1000">
          <div className="flex-column align-self-center justify-center">
            <h5 className="helloAK"><span style={{color:"yellow"}}>Hello,</span> I am Akash Kumar</h5>
            <div>
            <TypeAnimation
              sequence={[
                "Welcome to My Portfolio",
                1000,
                "I'm a Full Stack Developer",
                1000,
                "I'm a Backend Developer",
                1000, 
                "I'm a  Front-End Developer",
                1000,
                "I'm a MERN Stack Developer",
                1000,
              ]}
              speed={70}
              repeat={Infinity}
              className="txtAni"
              style={{color:"yellowgreen"}} 
            />
            </div>
          <a
            href={pdf}
            download="resume.pdf"
            className="btn btn-outline-warning my-4 px-4 py-2 " 
          >
            <span className="download-btn">Download</span> Resume
          </a>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12  my-5 mx-auto right">
          <div className="img" data-aos="fade-up-left" data-aos-duration="1000">
            <img src={`./assets/hero/akash.png`} alt="hero" className="imgPic" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
